import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, Col, Container, Form, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import CancelDialog from '../CancelDialog';
import * as Common from "../Common";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import Tran_data_unlock_request from '../Tran_data_unlock_request';
import Tran_date_change_modal from './Tran_date_change_modal';


function Tran_pi() {
    const taxClassOPtions = [{ value: 0, label: "Select" },
    { value: 1, label: "Gst" },
    { value: 2, label: "Unregistered" },
    { value: 3, label: "Gst Excluded" }];
    const productRef = useRef();
    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [key, setKey] = useState("INFO");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [accountFilter, setAccountFilter] = useState(null);

    const [counter, setCounter] = useState(0);
    const [hdrSrno, setHdrSrno] = useState(0);
    const [hdrDate, setHdrDate] = useState(new Date());
    const [radioType, setRadioType] = useState("N");
    const [piLocation, setPILocation] = useState(null);
    const [userRight, setUserRight] = useState([]);

    const [piNewDate, setPINewDate] = useState(new Date());
    const [piSrnoFrom, setPISrnoFrom] = useState("");
    const [piSrnoTo, setPISrnoTo] = useState("");
    const [piFromDate, setPIFromDate] = useState(new Date());
    const [piToDate, setPIToDate] = useState(new Date());
    const [piList, setPIList] = useState([]);
    const [piIndividual, setPIIndividual] = useState(null);
    const [piParty, setPIParty] = useState(null);

    const [nParty, setNParty] = useState(null);
    const [nBillDate, setNBillDate] = useState(null);
    const [nInvoiceNum, setNInvoiceNum] = useState("");
    const [nReverseCharge, setNReverseCharge] = useState("0");
    const [nRemark1, setNRemark1] = useState("");
    const [nRemark2, setNRemark2] = useState("");
    const [nState, setNState] = useState();
    const [nStateReceiver, setNStateReceiver] = useState(null);
    const [nStateSupplier, setNStateSupplier] = useState(null);
    const [nGstin, setNGstin] = useState("");
    const [nTaxClass, setNTaxClass] = useState("");

    const [piLocationValue, setPILocationValue] = useState(0);
    const [piStateValue, setPIStateValue] = useState(0);
    const [piStateType, setPIStateType] = useState("");
    const [piStateName, setPIStateName] = useState("");
    const [hdrLocation, setHdrLocation] = useState(0);
    const [scrMode, setScrMode] = useState("");

    //const [pVtm, setPVtm] = useState(null);
    const [pAccount, setPAccount] = useState(null);
    const [pAmount, setPAmount] = useState("");
    const [pFCgst, setPFCgst] = useState("");
    const [pFSgst, setPFSgst] = useState("");
    const [pTds, setPTds] = useState("");
    const [pSac, setPSac] = useState("");
    const [pTaxable, setPTaxable] = useState("");

    const [pTotalAmount, setPTotalAmount] = useState(0);
    const [pOtherCharges, setPOtherCharges] = useState(0);
    const [pCgst, setPCgst] = useState(0);
    const [pSgst, setPSgst] = useState(0);
    const [pIgst, setPIgst] = useState(0);
    const [pUgst, setPUgst] = useState(0);
    const [pForexTotal, setPForexTotal] = useState(0);
    const [pRoundOff, setPRoundOff] = useState(0);
    const [pTaxableVal, setPTaxableVal] = useState(0);
    const [productList, setProductList] = useState([]);
    const [productLineNo, setProductLineNo] = useState(1);

    const [disableOtherCharge, setDisableOtherCharge] = useState(true);

    const [pdAccount, setPdAccount] = useState(null);
    const [pdPaymentType, setPdPaymentType] = useState("");
    const [pdAmount, setPdAmount] = useState("");
    const [pdAccountOptions, setPdAccountOptions] = useState([]);
    const [pdAccountValue, setPdAccountValue] = useState("");
    const [pdGroupValue, setPdGroupValue] = useState(0);
    const [ldgSrchType, setLdgSrchType] = useState("");
    const [commission, setCommission] = useState("");
    const [pIsdId, setPIsdId] = useState("");
    const [maxPRate, setMaxPRate] = useState(0);
    const [minPRate, setMinPRate] = useState(0);
    const [pdChequeNum, setPdChequeNum] = useState("");
    const [paymentLineNo, setPaymentLineNo] = useState(1);
    const [paymentData, setPaymentData] = useState([]);

    const [viewDate, setViewDate] = useState('');
    const currentDate = new Date();
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [pFIgst, setPFIgst] = useState("");
    const [gstDisable, setGstDisable] = useState(false);
    const [compareData, setCompareData] = useState([]);

    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);
    const [dateChangeRight, setDateChangeRight] = useState();
    const [hdrDateYmd, setHdrDateYmd] = useState("");
    const [openDateChangeModal, setOpenDateChangeModal] = useState(false);
    const [changeDateObj, setChangeDateObj] = useState({});



    const [chequeValue, setChequeValue] = useState(null);
    const [chequeNum, setChequeNum] = useState(0);
    const [chequeLocation, setChequeLocation] = useState(0);
    const [chequeLineNo, setChequeLineNo] = useState(0);
    const [chequeSrno, setChequeSrno] = useState(0);

    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");
    const [asyncTdsVal, setAsyncTdsVal] = useState();
    const [tdsSrno, setTdsSrno] = useState(0);
    const [disablePaymentAccount, setDisablePaymentAccount] = useState(true);
    const [pdescGdSrv, setPdescGdSrv] = useState("");

    const [partyInvoiceDate, setPartyInvoiceDate] = useState(null);
    const [tdsSection, setTdsSection] = useState("");
    const [nExecutive, setNExecutive] = useState(null);
    const [accountNumber, setAccountNumber] = useState(null);
    const [ifscCode, setIfscCode] = useState("");
    const [executiveDetail, setExecutiveDetail] = useState(false);
    const [ldgAllBank, setLdgAllBank] = useState("");
    const [npartyy, setParty] = useState("PARTY");
    let sessionUserId = sessionStorage.userSrno;
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");
    const [piFundProcess, setPiFundProcess] = useState([]);


    useEffect(() => {
        Common.getActiveBranch().then(response => {
            setPILocation(response);
            response != null && handleLocationChange(response);
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_PI'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserCancelBillRight(resp);
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'PI_FUND_PROCESS'], function (result) {
            let resp = JSON.parse(result);
            setPiFundProcess(resp)
        });
        // Common.callApi(Common.apiResidentialStatus, [sid, "listResidential"], result => {
        //     setResidentOptions(JSON.parse(result));
        // });
        // Common.callApi(Common.apiState, [sid, "getState", 1], result => {
        //     setStateOptions(JSON.parse(result));
        // });
        Common.getDateChangeRight(sid, setDateChangeRight);//get right to change date
    }, []);


    const handleLocationChange = (value) => {
        setPILocation(value);
        var id = value.id;
        var location = id.split("^");
        setPILocationValue(location[1]);
        setPIStateValue(location[3] == null ? 0 : location[3]);
        setPIStateType(location[4]);
        setPIStateName(location[5] === "" ? "Select" : location[5]);
        setHdrLocation(location[2]);
        setNStateSupplier({
            id: location[3] == null ? 0 : location[3],
            label: location[5] === "" ? "Select" : location[5]
        });
        sessionStorage.activeBranch = location[1];
        setIsBranchDisableForAddNew(location[9]);
    }

    const handleIndiviualChange = (value) => {
        setPIIndividual(value);
    }

    const handleProductAccountChange = (value) => {
        const idArray = value.id.split('^');
        setPIParty(value);
        if (idArray[9] !== "") {
            setPTds(idArray[9])
        } else {
            setPTds("0");
        }
        //index 10->tds_section,11->percentage
        setTdsSection(idArray[10]);
        setTdsSrno(idArray[12]);
        setPTds(idArray[11]);
        setAsyncTdsVal({ id: '^ ^' + idArray[10] + '^' + idArray[11], value: idArray[10] + ' ' + idArray[11] })
    }

    const handlePartyChange = (value) => {
        setNParty(value);
        var id = value.id;
        var location = id.split("^");
        setNStateReceiver({
            id: location[5] == null ? 0 : location[5],
            label: location[6] === "" ? "Select" : location[6]
        });
        setNGstin(location[7]);
        const matchingOption = taxClassOPtions.find(val => val.value == location[14]);
        if (matchingOption) {
            setNTaxClass(matchingOption.value);
        } else {
            console.log("No match found for the value in location[10]");
        }
        if (location[5] === nStateSupplier.id) {
            setGstDisable(false);
        } else {
            setGstDisable(true);
        }
        const bankCode = value?.mvli_bank_code?.trim();
        const bankName = value?.mba_name?.trim();

        setLdgAllBank({
            id: !bankCode || bankCode.toLowerCase() === "null" ? "" : bankCode,
            label: !bankName || bankName.toLowerCase() === "null" ? "" : bankName
        });
        setAccountNumber(value?.mvli_account_num ?? "");
        setIfscCode(["null", null, undefined].includes(value?.mvli_bank_account_ifsc) ? "" : value.mvli_bank_account_ifsc);
    }

    const handleAccountFilter = (value) => {
        setAccountFilter(value);
    }

    const handleTabChange = (k) => {
        setKey(k);
        // if (k === "PAYMENT") {
        //     var amt = 0;
        //     for (var i = 0; i < paymentData.length; i++) {
        //         amt += paymentData[i].tp_amount * 1;
        //     }
        //     setPdAmount(1 * pTotalAmount - amt);
        //     const obj = {
        //         nCorporate: nCorporate
        //     }
        //     Common.callApi(Common.apiTranPP, [sid, "getcorporate", JSON.stringify(obj)], result => {
        //         setPdAccountOptions(JSON.parse(result));
        //     });
        // }
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    const otherChargeChange = (v) => {
        Common.validateDecValue(v, setPOtherCharges);
        // if (Common.isPurelyNumeric(v.trim())) {
        calcInvoice(productList, v, (pRoundOff ?? 0));
        // }
    }
    const roundOffChange = (v) => {
        Common.validateDecValue(v, setPRoundOff);
        calcInvoice(productList, pOtherCharges, v);
        // }
    }

    const calcInvoice = (productlist, othercharges, proundoffother = 0) => {
        if (othercharges === '') {
            othercharges = 0;
        }
        let forextotal = 0;
        let sgst = 0;
        let cgst = 0;
        let igst = 0;
        let tds = 0;
        let totalamount = 0;
        let taxablevalue = 0;
        // let roundoff = 0;
        for (var i = 0; i < productlist.length; i++) {
            forextotal = forextotal + productlist[i].inv_amount * 1;
            sgst = sgst + ((productlist[i].inv_taxable * 1) / 100) * productlist[i].inv_sgst * 1;
            cgst = cgst + ((productlist[i].inv_taxable * 1) / 100) * productlist[i].inv_cgst * 1;
            igst = igst + ((productlist[i].inv_taxable * 1) / 100) * productlist[i].inv_igst * 1;
            tds = tds + ((productlist[i].inv_amount * 1) / 100) * productlist[i].inv_tds * 1;

            taxablevalue = taxablevalue + productlist[i].inv_taxable * 1;
        }
        totalamount = (forextotal + Math.round(sgst*100)/100 + Math.round(cgst*100)/100 + Math.round(igst*100)/100 + (1 * othercharges) + (1 * proundoffother) - tds.toFixed(2)).toFixed(2);
        setPForexTotal(forextotal.toFixed(2));
        setPSgst(sgst.toFixed(2));
        setPTaxableVal(taxablevalue.toFixed(2));
        setPRoundOff(proundoffother);
        setPCgst(cgst.toFixed(2));
        setPIgst(igst.toFixed(2));
        setPTotalAmount(totalamount);
        setPTds(tds);
        setPUgst(0);
        var amt = 0;
        for (var i = 0; i < paymentData.length; i++) {
            amt += paymentData[i].tp_amount * 1;
        }
        setPdAmount((1 * totalamount - amt).toFixed(2));
    }

    const switchToPaymentTab = (e) => {
        if (e.key === 'Enter') setKey("PAYMENT");
        else if (e.key === "Tab") {
            e.preventDefault();
            productRef.current.focus();
        }
    }

    const handleAccountValue = (value) => {
        setPdAccount(value);
        var id = value.id.split("^");
        setPdGroupValue(id[1]);
        setPdAccountValue(id[2]);
    }

    const handlePaymentType = (v) => {
        $(".loader").show();
        setDisablePaymentAccount(false);
        setPdPaymentType(v);
        setPdAccount(null);
        setPdAccountValue(0);
        setPdChequeNum("");
        var ldgType = "";
        if (v === "") {
            $(".loader").hide();
            return;
        }
        if (v === "CH") {
            setLdgSrchType("CASH");
        } else if (v === "BN" || v === "CQ") {
            setLdgSrchType("BANK");
            $(".loader").hide();
            return;
        } else if (v === "PB") {
            if (nParty !== null) {
                setPdAccount(nParty);
                setDisablePaymentAccount(true);
                $(".loader").hide();
                return;
            }
        }
        Common.callApi(Common.apiLedger, [sid, "getledgerinfo", v == 'CH' ? "CASH" : (v == 'BN' || v == 'CQ') ? 'BANK' : "WALKING"], result => {
            let resp = JSON.parse(result);
            setPdAccount({ id: resp.id, label: resp.label });
            $(".loader").hide();
        });
        // else {
        //     setLdgSrchType("WALKIN");
        //     setPdAccount({ id: "^4516^1001^7^^WALK IN CLIENT^", label: "4516 1001 Walk In Client" });
        // }
    }

    const addNewForm = () => {
        var d = Common.dateYMD(piNewDate);
        var ddmy = Common.dateDMY(piNewDate);
        var today = Common.dateYMD(new Date());
        if (piLocation == null) {
            setMsgBox(true);
            setMsgText("Please select location");
        } else if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        }
        else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        }
        else {
            if (d == today) {
                addNewFormResetFields(ddmy);
            } else {
                const obj = {
                    billdate: d,
                    location: piLocationValue,
                    type: "PI"
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (resp.msg === "1") {
                        addNewFormResetFields(ddmy);
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });

            }
        }
    }

    const addNewFormResetFields = (ddmy) => {
        setNBillDate(piNewDate);
        setHdrDate(ddmy);
        setScrMode('A');
        setProductLineNo(1);
        setKey('INFO');
        setHdrSrno(0);
        setNParty(null);
        setPIParty(null);
        setNReverseCharge("0");
        setNInvoiceNum("");
        setNRemark1('');
        setNRemark2('');
        setProductList([]);
        setPaymentData([]);
        setPForexTotal(0);
        setPTotalAmount(0);
        setPTaxableVal(0);
        setPSgst(0);
        setPCgst(0);
        setPTds(0);
        setNStateReceiver(null);
        setNGstin("");
        setNTaxClass("");
        setGstDisable(true);
        setHdrDateYmd("");
        setPartyInvoiceDate(null);
    }


    const addProduct = () => {
        var msg = [], i = 0;
        if (piParty === null || !pAmount || !pTaxable
            // || (!gstDisable && !pFCgst) || (!gstDisable && !pFSgst) || (gstDisable && !pFIgst) || !pSac 
            || pdescGdSrv === "") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (piParty === null ? " Account." : "");
            msg[i++] = (!pAmount ? " Amount." : "");
            msg[i++] = (!pTaxable ? " GST Taxable Value(INR)." : "");
            /*
            msg[i++] = ((!gstDisable && !pFCgst) ? " CGST." : "");
            msg[i++] = ((!gstDisable && !pFSgst) ? " SGST." : "");
            msg[i++] = ((gstDisable && !pFIgst) ? "IGST" : "");
            msg[i++] = (!pSac ? " SAC." : ""); 
            */
            msg[i++] = (pdescGdSrv === "" ? " Description of Services/Goods." : "");

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            let accnt = 0;
            let grp = 0;
            let ledger_name = "";
            let corp = piParty.id.split("^");
            grp = corp[1];
            accnt = corp[2];
            ledger_name = corp[3];
            const obj = {
                type: "PURCHASE",
                uniquekey: Common.getRandomString(15),
                inv_line_no: productLineNo,
                inv_location: piLocationValue,
                inv_type: 'PI',
                inv_group: grp,
                inv_account: accnt,
                mvli_ledger_name: ledger_name,
                inv_srno: hdrSrno,
                inv_date: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(piNewDate),
                inv_amount: pAmount,
                inv_taxable: pTaxable,
                // inv_qty: pQuantity,
                // inv_rate: pRate,
                inv_sac: pSac,
                inv_tds: pTds === "" ? 0 : pTds,
                // inv_tds1: pTds1 === "" ? 0 : pTds1,
                inv_sgst: pFSgst === "" ? 0 : pFSgst,
                inv_cgst: pFCgst === "" ? 0 : pFCgst,
                inv_igst: pFIgst === "" ? 0 : pFIgst,
                // inv_pservice: pservice,
                inv_descgs: pdescGdSrv,
                inv_sgst_calc: pFSgst === "" ? 0 : ((pTaxable * pFSgst) / 100).toFixed(2),
                inv_cgst_calc: pFCgst === "" ? 0 : ((pTaxable * pFCgst) / 100).toFixed(2),
                inv_igst_calc: pFIgst === "" ? 0 : ((pTaxable * pFIgst) / 100).toFixed(2),
                inv_tds_calc: pTds === "" ? 0 : ((pAmount * pTds) / 100).toFixed(2),
                // inv_tds1_calc: pTds1 === "" ? 0 : ((pAmount * pTds1) / 100).toFixed(2),
                inv_total_amount: parseFloat((Number(pAmount) + (Number(pTaxable) * (Number(pFSgst) + Number(pFCgst) + Number(pFIgst)) / 100)).toFixed(2)),
                prd_product: 'PI',
                prd_amount: pAmount,
                delny: "Y",
                tds_srno: tdsSrno == null ? 0 : tdsSrno,
                tds_section: tdsSection
            }

            const productlist = Common.arrayAddItem(productList, obj);
            if (productlist.length > 0) {
                setDisableOtherCharge(false);
            }
            const obj2 = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                // TLine: productLineNo + 1,
                TLoc: piLocationValue,
                TType: 'PI',
                Group: grp,
                Ledger: accnt,
                Amount: pAmount,
                Taxable: pTaxable,
                SAC: pSac,
                TDS: pTds,
                SGST: pFSgst,
                CGST: pFCgst,
                IGST: pIgst,
                tds_srno: tdsSrno,


            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            setProductList(productlist);
            setPAccount(null);
            setPAmount("");
            setPTaxable("");
            setPFCgst("");
            setPFSgst("");
            setPSac("");
            setPTds("");
            // setPRate("");
            // setPService("");
            setPdescGdSrv("");
            setPIgst("");
            setPFIgst("");
            calcInvoice(productlist, pOtherCharges, (pRoundOff ?? 0));
            setPIParty(null);
            setAsyncTdsVal();
            setTdsSrno(0);
            setTdsSection("");
            setProductLineNo(productLineNo + 1);
            setCounter(counter + 1);
        }
    }

    const addPayment = () => {
        console.log("Payment Value : ", pdAccount);
        var msg = [], i = 0;
        if (pTotalAmount < 1) {
            msg[i++] = (pTotalAmount < 1 ? "Total amount must be greater than 0." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pdPaymentType === "" || pdAccount === null || pdAmount < 1 || (pdPaymentType === "BN" && pdChequeNum === "") || (pdPaymentType === 'CQ' && chequeValue === null)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pdAccount === null ? "Account." : '');
            msg[i++] = (pdPaymentType === "" ? "Payment Type." : '');
            msg[i++] = (pdAmount < 1 ? "Entered amount can't be 0." : '');
            if (pdPaymentType === 'CQ' && chequeValue === null) msg[i++] = (chequeValue === null ? "Select a Cheque." : '');
            if (pdPaymentType === "BN" && pdChequeNum === "") msg[i++] = (pdChequeNum === "" ? "Refernece Number." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } 
        
        else if (pdPaymentType === 'PB' && (ldgAllBank === "" || accountNumber === "" || ifscCode === "")) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ldgAllBank === "" ? " Bank name . " : '');
            msg[i++] = (accountNumber === "" ? "Account Number ." : '');
            msg[i++] = (ifscCode === "" ? "IFSC Code . " : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }   
        
        else {
            var grp = 0;
            var accnt = 0;
            var accntname = '';
            if (pdAccount !== null) {
                var a = pdAccount.id.split("^");
                grp = a[1];
                accnt = a[2];
                accntname = a[3];
                // if (pdPaymentType === 'PB') {
                //      accntname = a[3];
                // } else {
                //     accntname = a[5];
                // }
            }
            let tcbb_srno = 0;
            let tcbb_line_no = 0;
            let tcbb_location = 0;
            let tcbb_from = 0;
            let tcbb_type = '';

            if (pdPaymentType === "CQ") {
                const ch = chequeValue.id.split("^");
                tcbb_srno = ch[1];
                tcbb_line_no = ch[2];
                tcbb_location = ch[3];
                tcbb_from = ch[4];
                tcbb_type = ch[5];
            }
            // console.log("nExecutivenExecutive",nExecutive)
            const obj = {
                uniquekey: Common.getRandomString(10),
                tp_line_no: paymentLineNo,
                tp_location: piLocationValue,
                tp_srno: hdrSrno,
                tp_payment_type: pdPaymentType,
                tp_account: accnt,
                tp_group: grp,
                mvli_ledger_name: accntname,
                tp_amount: pdAmount,
                tp_cheque: pdChequeNum,
                tp_type: "PINV",
                tcbb_from: chequeNum,
                prd_product: 'PI',
                delny: 'Y',
                tcbb_srno: tcbb_srno,
                tcbb_line_no: tcbb_line_no,
                tcbb_location: tcbb_location,
                tcbb_from: tcbb_from,
                tcbb_type: tcbb_type,
                bank_code: `${ldgAllBank?.id} - ${ldgAllBank?.label}`,
                accnum: accountNumber,
                ifsc: ifscCode,
                nparty: npartyy,
                executive: nExecutive?.label
            }
            const existingItem = Common.isSamePaymentMethod(obj, paymentData);
            if (existingItem) {
                existingItem.tp_amount = (existingItem.tp_amount * 1 || 0) + (obj.tp_amount * 1 || 0);
                existingItem.tp_cheque = pdChequeNum;
                existingItem.tcbb_from = chequeNum;
            } else {
                const paymentdata = Common.arrayAddItem(paymentData, obj);
                console.log("Payment Data is :", paymentData);
                setPaymentData(paymentdata);
                const obj2 = {
                    TabType: "Payment",
                    AType: "A",
                    ALineNo: tranAuditTrail.length + 1,
                    // TLine: paymentLineNo + 1,
                    TLoc: piLocationValue,
                    TType: 'PI',
                    PaymentType: pdPaymentType,
                    PaymentLedgerCode: accnt,
                    PaymentGroupCode: grp,
                    PaymentAccountName: accntname,
                    PaymentAmount: pdAmount,
                    // ...(pdPaymentType == "BN" ? {
                    ReferenceNo: pdChequeNum,
                    // } : {}),

                }
                if (userRight.edit === "1" && scrMode === 'E') {
                    setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
                }
            }
            setPdPaymentType("");
            setPaymentLineNo(paymentLineNo + 1);
            setPdAmount("");
            setPdAccount(null);
            setChequeValue(null);
            setChequeLineNo("");
            setChequeLocation("");
            setChequeSrno("");
            //setChequeValue(null);
            //setChequeLocation("");
            //setChequeSrno("");
            setCounter(counter + 1);
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
            setPdAmount(1 * pTotalAmount - amt);
        }
    }

    const deleteProduct = (value) => {
        console.log("Value : ", value);
        console.log("Value of available productlist", productList);
        const itemToDelete = productList.find(item => item.uniquekey === value);
        console.log("Item to Delete : ", itemToDelete);
        if (itemToDelete) {
            const formattedItem = {
                Product: itemToDelete.prd_product,
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: piLocationValue,
                TType: 'PINV',
                Group: itemToDelete.inv_group,
                Ledger: itemToDelete.inv_account,
                Amount: itemToDelete.inv_amount,
                Taxable: itemToDelete.inv_taxable,
                SAC: itemToDelete.inv_sac,
                TDS: itemToDelete.inv_tds,
                SGST: itemToDelete.inv_sgst,
                CGST: itemToDelete.inv_cgst,
                IGST: itemToDelete.inv_igst
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }
        }
        const productlist = Common.arrayRemoveItem(productList, "uniquekey", value);
        console.log("this is productlist after delete", productlist);
        setProductList(productlist);
        calcInvoice(productlist, (pOtherCharges || 0), pRoundOff);
        setCounter(counter - 1);
    }

    const deletePayment = (value, delny) => {
        const itemToDelete = paymentData.find(item => item.uniquekey === value);

        if (itemToDelete) {
            const formattedItem = {
                TabType: "Payment",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLine: paymentLineNo + 1,
                TLoc: piLocationValue,
                TType: 'PI',
                PaymentType: itemToDelete.tp_payment_type,
                PaymentGroupCode: itemToDelete.tp_group,
                PaymentLedgerCode: itemToDelete.tp_account,
                PaymentAccountName: itemToDelete.mvli_ledger_name,
                PaymentAmount: itemToDelete.tp_amount,
                ReferenceNo: itemToDelete.tp_cheque,
            };
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }

        }
        const paymentdata = Common.arrayRemoveItem(paymentData, "uniquekey", value);
        setPaymentData(paymentdata);
        var amt = 0;
        for (var i = 0; i < paymentdata.length; i++) {
            amt += paymentdata[i].tp_amount * 1;
        }
        setPdAmount(1 * pTotalAmount - amt);
        //}
        setCounter(counter - 1);
    }

    const saveData = () => {
        $(".loader").show();
        var totalinr = 0;
        for (var i = 0; i < paymentData.length; i++) {
            if (paymentData[i].tp_payment_type === "RC")
                totalinr -= paymentData[i].tp_amount * 1;
            else totalinr += paymentData[i].tp_amount * 1;
        }
        var msg = [], i = 0;
        let billdate = Common.dateYMD(piNewDate);
        if (hdrSrno > 0) {
            billdate = hdrDateYmd;
        }
        if ((nInvoiceNum === "" || nParty === null) || (pTotalAmount != totalinr && scrMode === 'A') || nStateReceiver.id === "" || nStateSupplier.id === "" || partyInvoiceDate == null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (nBillDate === null ? "Bill Date." : '');
            msg[i++] = (nInvoiceNum === '' ? "Invoice Number." : '');
            msg[i++] = (nParty === null ? "Party." : '');
            msg[i++] = ((pTotalAmount != totalinr && scrMode === 'A') ? "Total amount of payment must be equal to calculated INR." : "");
            msg[i++] = (nStateReceiver.id === "" ? "State of Reciever can't be Empty." : "");
            msg[i++] = (nStateSupplier.id === "" ? "State of Supplier can't be Empty." : "");
            msg[i++] = (partyInvoiceDate == null ? "Party invoice Date." : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else if (scrMode === 'A' && productList.length < 1) {
            setMsgText("Productlist can't be empty.");
            setMsgBox(true);
            $(".loader").hide();
        } else {
            const obj = {
                srno: hdrSrno,
                piLocationValue: piLocationValue,
                nParty: nParty,
                nInvoiceNum: nInvoiceNum,
                nBillDate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(piNewDate),
                nReverseCharge: nReverseCharge,
                nRemark1: nRemark1,
                nRemark2: nRemark2,
                piNewDate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(piNewDate),
                pForexTotal: pForexTotal,
                pSgst: pSgst,
                pIgst: pIgst,
                pUgst: pUgst,
                pCgst: pCgst,
                pOtherCharges: pOtherCharges || 0,
                pRoundOff: pRoundOff,
                pTaxableVal: pTaxableVal === "" ? 0 : pTaxableVal,
                pTotalAmount: pTotalAmount || 0,
                nTaxClass: nTaxClass === "" ? 0 : nTaxClass,
                nStateReceiver: nStateReceiver,
                nStateSupplier: nStateSupplier,
                nGstin: nGstin,
                productList: productList,
                paymentData: paymentData,
                tdsSrno: tdsSrno,
                ptds: pTds,
                partyInvoiceDate: Common.dateYMD(partyInvoiceDate),
                // accountNumber:accountNumber,
                // ifscCode:ifscCode,
                // ldgAllBank:ldgAllBank,
                // account_type:nparty,
                // executive:nExecutive
            }
            const infoObject = Common.compareArrays(compareData, [obj]);

            if (userRight.edit === "1" && scrMode === "E") {
                setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'PI', piLocationValue));
            }
            Common.callApi(Common.apiTranPI, [sid, "savedata", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], result => {
                let resp = JSON.parse(result);
                if (resp.msg === "MSG0000") {
                    $(".loader").hide();
                    setScrMode("");
                    setMsgBox(true);
                    setMsgText(Common.getMessage(resp.msg));
                    listPIdata();
                    setTranAuditTrail([]);
                } else {
                    $(".loader").hide();
                    setMsgBox(true);
                    if (resp.msg.includes("Cancellation") || resp.msg.includes("Modification")) {
                        setMsgText(resp.msg);
                    } else {
                        setMsgText(Common.getMessage(resp.msg));
                    }
                }
            });
            if (scrMode == 'E' && unlockRequestType !== "SELF") {
                const obj = {
                    srno: hdrSrno,
                    type: 'PI',
                    status: 'E',
                    currentDate: Common.dateYMD(currentDate),
                    pageright: 'TRAN_PI'
                }
                Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                })

            }
        }
    }
    const fillViewCompareObject = (resp) => {
        const obj2 = {
            nParty: { id: resp.acct_id, label: resp.acct_label },
            nInvoiceNum: resp.invoice,
            nBillDate: resp.bill_date,
            nReverseCharge: resp.reversecharge,
            nRemark1: resp.remark1,
            nRemark2: resp.remark2,
            pForexTotal: resp.forextotal,
            pTotalAmount: resp.total_inr,
            nStateReceiver: { id: resp.receiver_state_id, label: resp.receiver_state_name },
            nStateSupplier: { id: resp.supply_state_id, label: resp.supply_state_name },
        };
        setCompareData([obj2]);
    }

    const fillViewForm = (hdrsrno, location, type, date) => {
        setHdrSrno(hdrsrno);
        setKey('INFO');
        setViewDate(date);
        // setRandomString("0");
        $(".loader").show();
        const obj = {
            srno: hdrsrno,
            piLocationValue: location,
            type: type
        }
        Common.callApi(Common.apiTranPI, [sid, "viewdata", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "MSG0000") {
                $(".loader").hide();
                setScrMode("Q");
                fillViewCompareObject(resp);
                setNRemark1(resp.remark1);
                setNRemark2(resp.remark2);
                setNReverseCharge(resp.reversecharge);
                setNParty({ id: resp.acct_id, label: resp.acct_label });
                setNInvoiceNum(resp.invoice);
                setNBillDate(new Date(resp.bill_date));

                setPForexTotal(resp.forextotal);
                setPCgst(resp.cgst);
                setPSgst(resp.sgst);
                setPIgst(resp.igst);
                setPUgst(resp.ugst);
                setPTds(resp.tds);
                setPRoundOff(resp.round_off);
                setPTotalAmount(resp.total_inr);
                setPOtherCharges(resp.other_charge);
                setPTaxableVal(resp.taxablevalue);
                setHdrDate(resp.date);
                setProductLineNo(resp.maxlineno * 1);
                setProductList(resp.productlist);
                setPaymentLineNo(resp.paymaxlineno * 1);
                setPaymentData(resp.paydetails);
                setHdrSrno(resp.srno);
                setNStateReceiver({ id: resp.receiver_state_id, label: resp.receiver_state_name });
                setNStateSupplier({ id: resp.supply_state_id, label: resp.supply_state_name });
                setNParty({ id: resp.acct_id, label: resp.acct_label });
                setNGstin(resp.gstin);
                setPartyInvoiceDate(new Date(resp.invoicedate));
                setNTaxClass(resp.taxclass);/////. ye thik karna h 
                var id = resp.acct_id;
                var location = id.split("^");
                if (resp.receiver_state_id === resp.supply_state_id) {
                    setGstDisable(false);
                } else {
                    setGstDisable(true);
                }
                const matchingOption = taxClassOPtions.find(val => val.value == location[14]);
                if (matchingOption) {
                    setNTaxClass(matchingOption.value);
                }
                setHdrDateYmd(resp.hdrdateymd);
            }
        });
    }
    const gstEnableDisable = (value) => {

    }

    const listPIdata = () => {
        var msg = [], i = 0;
        $(".loader").show();
        if (piLocation === null || (radioType === 'S' && !piSrnoFrom) || (radioType === 'S' && !piSrnoTo) || (radioType === 'D' && !piFromDate)
            || (radioType === 'D' && !piToDate) || (radioType === 'I' && piIndividual === null) || (radioType === 'I' && !piFromDate) || (radioType === 'I' && !piToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (piLocation === null ? " Location." : '');
            msg[i++] = (radioType === 'S' && !piSrnoFrom ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && !piSrnoTo ? " To Srno." : '');
            msg[i++] = (radioType === 'D' && !piFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !piToDate ? " To Date." : '');
            msg[i++] = (radioType === 'I' && piIndividual === null ? " Individual." : '');
            msg[i++] = (radioType === 'I' && !piFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'I' && !piToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                radioType: radioType,
                piLocation: piLocationValue,
                accountFilter: accountFilter,
                piNewDate: Common.dateYMD(piNewDate),
                piSrnoTo: piSrnoTo,
                piSrnoFrom: piSrnoFrom,
                piFromDate: Common.dateYMD(piFromDate),
                piToDate: Common.dateYMD(piToDate),
            }
            Common.callApi(Common.apiTranPI, [sid, "pilist", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setPIList(JSON.parse(result));
            });
        }
    }

    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        console.log(differenceInDays);
        const obj = {
            srno: hdrSrno,
            type: 'PI',
            pageright: 'TRAN_PI',
            location: piLocationValue
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit >= differenceInDays || resp.msg == "unlock") {
                setScrMode('E');
                if (productList.length > 0) {
                    setDisableOtherCharge(false);
                }
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'PI', trannumber: hdrSrno, location: piLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })


    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "PI", trannumber: hdrSrno, trancategory: "T", location: piLocationValue });
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: piLocationValue, trannumber: hdrSrno, type: 'PI' });
    }
    const handleChequeValue = (value) => {
        setChequeValue(value);
        var id = value.id.split("^");
        setChequeSrno(id[1]);
        setChequeLineNo(id[2]);
        setChequeLocation(id[3]);
        setChequeNum(id[4]);
    }
    const handleCancelBill = () => {
        setMsgTextYNBillDelete("Are you sure.");
        setMsgBoxYNBillDelete(true);
    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'PI',
            location: piLocationValue,
            srno: hdrSrno,
            productList: productList,
            paymentList: paymentData,
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                listPIdata();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }

    const changeDateModal = () => {
        var isOk = true;
        var msg = [], i = 0;
        // if (productList.length > 0) {
        //     isOk = false;
        //     msg[i++] = "Please empty Product List.";
        // }
        // if (paymentData.length > 0) {
        //     isOk = false;
        //     msg[i++] = "Please empty Payment List.";
        // }
        if (isOk) {
            setOpenDateChangeModal(true);
            setChangeDateObj(
                {
                    type: "PI",
                    srno: hdrSrno,
                    location: piLocationValue,
                    right: "TRAN_PI",
                    billdate: hdrDate,
                    billdateymd: hdrDateYmd,
                    productList: piList,

                    // depDate: Common.dateYMD(nDepDate)
                }
            );
        } else {
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }
    const tdsHandler = (val) => {
        console.log(val);
        setAsyncTdsVal(val)
        setTdsSrno(val.id.split('^')[1])//tds srno
        // setLdgTds(val.id.split('^')[3]);// percentage
        setPTds(val.id.split('^')[3]);
        setTdsSection(val.id.split('^')[2]);
    }

    const print = () => {
        $(".loader").show();
        const obj = {
            srno: hdrSrno,
            location: piLocationValue,
            type: 'PI',
        }
        Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
            $(".loader").hide();
            var newWindow = window.open();
            newWindow.document.write(result);
        });
    }

    const handleExecutiveChange = (value) => {
        setNExecutive(value);
        setExecutiveDetail(true)
        const obj = {
            srno: value,

        }
        Common.callApi(Common.apiTranPI, [sid, "get_executive", JSON.stringify(obj)], result => {
            let res = JSON.parse(result);
            setAccountNumber(res?.me_account_number || "");
            setIfscCode(res?.me_ifsc_code || "");
            setLdgAllBank({ id: res?.me_bankcode, label: res?.me_bank_name });
        });
    }

    const handleNextBill = () => {
        if (!hdrSrno || !piLocationValue) {
            setMsgText("Bill Srno and Location required");
            setMsgBox(true);
        }

        // if hdrsrno and location available
        const obj = {
            srno: hdrSrno,
            location: piLocationValue,
            type: "PI"
        };

        // Common.callApi(Common.apiCommom, 'Nextbillexists', JSON.stringify(obj), (result) => {
        Common.callApi(Common.apiCommom, [sid, "Nextbillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            if (resp.srno) {
                fillViewForm(resp.srno, piLocationValue, "PI", resp.date);
            } else {
                setMsgText("No next bill available.");
                setMsgBox(true);
            }
        })

    }
    const handlePrevBill = () => {
        if (!hdrSrno || !piLocationValue) {
            setMsgText("Bill Srno and Location required");
            setMsgBox(true);
        }

        // if hdrsrno and location available
        const obj = {
            srno: hdrSrno,
            location: piLocationValue,
            type: "PI"
        };

        // Common.callApi(Common.apiCommom, 'Nextbillexists', JSON.stringify(obj), (result) => {
        Common.callApi(Common.apiCommom, [sid, "Prebillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            if (resp.srno) {
                fillViewForm(resp.srno, piLocationValue, "PI", resp.date);
            } else {
                setMsgText("No Previous bill available.");
                setMsgBox(true);
            }
        })
    }

    const accountTypeHandler = (value) => {
        setParty(value)
        setLdgAllBank("");
        setAccountNumber("");
        setIfscCode("");
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Purchase Invoice</h2>
                    </Col>
                </Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={piLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleLocationChange}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col style={{ display: "flex" }}>
                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                                <Form.Check checked={radioType === "I"} onChange={() => setRadioType("I")} type='radio' label="Individual" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === "N" ?
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Date</Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={piNewDate}
                                                    onChange={(date) => setPINewDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        : radioType === "S" ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={5} value={piSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setPISrnoFrom)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={5} value={piSrnoTo} onChange={e => Common.validateNumValue(e.target.value, setPISrnoTo)} />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            : radioType === "D" || radioType === "I" || radioType === "C" ?
                                                <>
                                                    {
                                                        radioType === "I" ?
                                                            <Col className="col-md-6 col-12">
                                                                <Form.Group>
                                                                    <Form.Label>Individual Profile<span className="colorThemeRed">*</span></Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={piIndividual}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={(search) => Picklist.fetchIndividualPicklist(search)}
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={handleIndiviualChange}
                                                                        formatOptionLabel={Picklist.formatOptionLabel}
                                                                        components={{ Menu: Picklist.menu }}
                                                                    >
                                                                    </AsyncSelect>

                                                                </Form.Group>
                                                            </Col>
                                                            : null
                                                    }
                                                    {
                                                        radioType === "C" ?
                                                            <Col className="col-md-6 col-12">
                                                                <Form.Group>
                                                                    <Form.Label>Corporate<span className="colorThemeRed">*</span></Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={accountFilter}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, piLocationValue)} // location = 1 , 2
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={handleAccountFilter}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Form.Group>
                                                            </Col>
                                                            : null
                                                    }
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={piFromDate}
                                                                onChange={(date) => setPIFromDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={piToDate}
                                                                onChange={(date) => setPIToDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                                : null
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.query === "1" && radioType !== "N" ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listPIdata()}>List</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        userRight.add === "1" && radioType === "N" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNewForm()}>Add New</Button> : null
                                    }
                                    &nbsp;


                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Table responsive striped>
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Sr No </th>
                                            <th>Type</th>
                                            <th>Location</th>
                                            <th>Bill Date</th>
                                            <th>Account</th>
                                            <th>Party Invoice No</th>
                                            <th>Invoice Total</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            piList.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <span onClick={() => fillViewForm(item.hdr_srno, item.hdr_location, item.hdr_type, item.new_date)} className='pointer colorThemeBlue'>
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{item.hdr_srno}</td>
                                                    <td>{item.hdr_type}</td>
                                                    <td>{item.entity_name}</td>
                                                    <td>{item.hdr_bill_date}</td>
                                                    <td>{item.mvli_ledger_name}</td>
                                                    <td>{item.hdr_invoice}</td>
                                                    <td style={{ textAlign: 'right' }}>{item.hdr_total_inr}</td>
                                                    <td>{item.hdr_date}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.query === "1" && scrMode === "Q") ? <>
                                            {/* <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => print("D")}>With Deno</Button>&nbsp; */}
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => print("")}>Print</Button>&nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                        </> : null
                                    }

                                    {(userRight.query === "1" && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    }
                                    {
                                        scrMode === "Q" &&
                                        <Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                    }
                                    {dateChangeRight?.query === '1' && scrMode === "Q" &&
                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => changeDateModal()}>Date Change</Button>}
                                    {
                                        (scrMode === "Q" && userCancelBillRight.query === "1") &&
                                        <>
                                            &nbsp;
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.query === 1) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-primary    " className='buttonStyle' size="sm" onClick={() => handlePrevBill()}>Prev Bill</Button>
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.query === 1) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleNextBill()}>Next bill</Button>
                                        </>
                                    }
                                    {/* cancel button only for testing purpose  */}
                                    {/* {  <>
                                        &nbsp;
                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                    </>} */}
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Serial Number : {hdrSrno}</Form.Label>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Location : <b>{hdrLocation} </b></span>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Date : <b>{hdrDate}</b></span>
                                </Col>
                                <Col className='ppCharges'>
                                    <span><b>Product Total (INR): {pForexTotal}</b></span>
                                    &nbsp;
                                    <span><b>Invoice Amount (INR): {pTotalAmount}</b></span>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                <Tab eventKey="INFO" title="Info">
                                    <Row>
                                        {
                                            /*
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Bill Date<span className='colorThemeRed'>*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={nBillDate}
                                                        onChange={(date) => setNBillDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        disabled={true}
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                            */
                                        }

                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Party Invoice No<span className='colorThemeRed'>*</span></Form.Label>
                                                <Form.Control placeholder='Invoice No.' disabled={scrMode === "Q"} type='text' maxLength={20} value={nInvoiceNum} onChange={e => setNInvoiceNum(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Party Invoice Date<span className='colorThemeRed'>*</span></Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={partyInvoiceDate}
                                                    onChange={(date) => setPartyInvoiceDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    disabled={scrMode === "Q"}
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-6 col-12'>
                                            <Form.Group>
                                                <Form.Label>
                                                    <span>Party<span className="colorThemeRed">*</span></span>
                                                    <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={() => setNParty(null)}><Badge bg="secondary">Reset</Badge></span>
                                                </Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nParty}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, piLocationValue)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handlePartyChange}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Reverse Charge</Form.Label>
                                                <Form.Select disabled={scrMode === "Q"} value={nReverseCharge} onChange={e => setNReverseCharge(e.target.value)}>
                                                    <option value="0">No</option>
                                                    <option value="1">Yes</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Remark 1</Form.Label>
                                                <Form.Control type="text" maxLength={100} placeholder='Remark 1' disabled={scrMode === "Q"} value={nRemark1} onChange={e => setNRemark1(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Remark 2</Form.Label>
                                                <Form.Control type="text" maxLength={100} placeholder='Remark 2' disabled={scrMode === "Q"} value={nRemark2} onChange={e => setNRemark2(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>State of Supplier</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nStateSupplier}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchStatePicklist(search, 1)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={(value) => setNStateSupplier(value)}
                                                    isDisabled={true}
                                                ></AsyncSelect>

                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>State of Receiver</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nStateReceiver}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchStatePicklist(search, 1)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={(value) => setNStateReceiver(value)}
                                                    isDisabled={true}
                                                ></AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>GSTIN</Form.Label>
                                                <Form.Control type="text" maxLength={30} placeholder='GSTIN' disabled={true} value={nGstin} onChange={e => setNGstin(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Tax Classification</Form.Label>
                                                <Form.Select
                                                    value={nTaxClass}
                                                    onChange={e => setNTaxClass(e.target.value)}
                                                    disabled={true}
                                                >
                                                    {taxClassOPtions.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>


                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("DETAILS")}>Product-&gt;</Button>
                                        </Col>
                                    </Row>
                                </Tab>
                                <Tab eventKey="DETAILS" title="Details">
                                    <Row>
                                        <Col>
                                            <h4>Product Info</h4>
                                        </Col>
                                    </Row>
                                    {
                                        scrMode === "Q" ? null :
                                            <>
                                                <Row>
                                                    <Col className='col-md-6 col-12'>
                                                        <Form.Group>
                                                            <Form.Label>Account<span className='colorThemeRed'>*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={piParty}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, piLocationValue)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleProductAccountChange}
                                                                isDisabled={scrMode === "Q"}
                                                                ref={productRef}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Amount<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control placeholder='Amount' type='text' maxLength={10} value={pAmount} onChange={e => Common.validateDecValue(e.target.value, setPAmount)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>GST Taxable Value(INR)<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control placeholder='Amount' type='text' maxLength={10} value={pTaxable} onChange={e => Common.validateDecValue(e.target.value, setPTaxable)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>SGST %</Form.Label>
                                                            <Form.Control disabled={gstDisable} placeholder='%' type='text' maxLength={5} value={pFSgst} onChange={e => Common.validateDecValue(e.target.value, setPFSgst)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>CGST %</Form.Label>
                                                            <Form.Control disabled={gstDisable} placeholder='%' type='text' maxLength={5} value={pFCgst} onChange={e => Common.validateDecValue(e.target.value, setPFCgst)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>IGST %</Form.Label>
                                                            <Form.Control disabled={!gstDisable} placeholder='%' type='text' maxLength={5} value={pFIgst} onChange={e => Common.validateDecValue(e.target.value, setPFIgst)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>SAC</Form.Label>
                                                            <Form.Control placeholder='SAC' type='text' maxLength={10} value={pSac} onChange={e => Common.validateDecValue(e.target.value, setPSac)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>TDS(%)</Form.Label>
                                                            {/* <Form.Control disabled={visiblePg === 'Q'} type="text" value={ldgTds} 
                                                                onChange={e => Common.validateDecValue(e.target.value, setLdgTds)} /> */}
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={asyncTdsVal}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={Picklist.fetchTdsList}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={tdsHandler}
                                                                formatOptionLabel={Picklist.tdsFormatOptionLabel}
                                                                components={{ Menu: Picklist.tdsMenu }}
                                                            // isDisabled={visiblePg === 'Q'}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>TDS<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control placeholder='%' type='text' maxLength={10} value={pTds}
                                                                disabled onChange={e => Common.validateDecValue(e.target.value, setPTds)} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Form.Group>
                                                            <Form.Label>Description of Services/Goods<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control
                                                                value={pdescGdSrv}
                                                                maxLength={500}
                                                                as="textarea"
                                                                placeholder="Leave a comment here"
                                                                style={{ height: '100px' }}
                                                                onChange={(e) => setPdescGdSrv(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addProduct()}>Add</Button>
                                                        &nbsp;
                                                        <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("PAYMENT")} onKeyDown={switchToPaymentTab}>Payment-&gt;</Button>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                            </>
                                    }
                                    <Row>
                                        <Table responsive bordered striped>
                                            <thead>
                                                <tr>
                                                    <th>Group</th>
                                                    <th>Account</th>
                                                    <th>Account Name</th>
                                                    <th>Amount</th>
                                                    <th>Taxable Value</th>
                                                    <th>SGST</th>
                                                    <th>CGST</th>
                                                    <th>IGST</th>
                                                    <th>SAC</th>
                                                    <th>TDS</th>
                                                    <th>Description Good/Service</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    productList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.inv_group}</td>
                                                            <td>{item.inv_account}</td>
                                                            <td>{item.mvli_ledger_name}</td>
                                                            <td>{item.inv_amount}</td>
                                                            <td>{item.inv_taxable}</td>
                                                            <td>{item.inv_sgst_calc}</td>
                                                            <td>{item.inv_cgst_calc}</td>
                                                            <td>{item.inv_igst_calc}</td>
                                                            <td>{item.inv_sac}</td>
                                                            <td>{(item.tds_section || '') + ' ' + item.inv_tds + '%'}</td>
                                                            <td>{item.inv_descgs}</td>
                                                            <td>
                                                                {
                                                                    scrMode === "Q" || item.delny === "N" ? null :
                                                                        <span onClick={() => deleteProduct(item.uniquekey)} className='colorThemeBlue pointer'>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </span>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                                </Tab>
                                <Tab eventKey="PAYMENT" title="Payments">
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>Taxable Value: {pTaxableVal}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>SGST: {pSgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>IGST: {pIgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>CGST : {pCgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>UGST : {pUgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>Round Off: {pRoundOff}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>Tds : {pTds}</Form.Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                            <Form.Group>
                                                <Form.Label>Amount</Form.Label>
                                                <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                    maxLength={5}
                                                    value={pOtherCharges}
                                                    onChange={e => otherChargeChange(e.target.value)}
                                                    disabled={disableOtherCharge || scrMode === "Q"}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                            <Form.Group>
                                                <Form.Label>Round off Amount</Form.Label>
                                                <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                    maxLength={5}
                                                    value={pRoundOff}
                                                    onChange={e => roundOffChange(e.target.value)}
                                                    disabled={disableOtherCharge || scrMode === "Q"}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col>
                                            <h4>Payment Details</h4>
                                        </Col>
                                    </Row>
                                    {
                                        scrMode === "Q" ? null
                                            :
                                            <>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Payment Type</Form.Label>
                                                            <Form.Select value={pdPaymentType} onChange={e => handlePaymentType(e.target.value)}
                                                            // onBlur={e => handlePaymentType(e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="CH">Cash</option>
                                                                <option value="BN">Bank</option>
                                                                <option value="CQ">Cheque</option>
                                                                <option value="PB">Payables</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Account<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pdAccount}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, ldgSrchType, piLocationValue)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleAccountValue}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        pdPaymentType !== "" ?
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Amount</Form.Label>
                                                                    <Form.Control placeholder='Amount' value={pdAmount} onChange={e => Common.validateDecValue(e.target.value, setPdAmount)} />
                                                                </Form.Group>
                                                            </Col> : null
                                                    }

                                                    {pdPaymentType === "PB" && (piFundProcess.add == '1' || piFundProcess.edit == '1') ?
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Account Type</Form.Label>
                                                                <Form.Select disabled={scrMode === "Q"} value={npartyy} onChange={e => accountTypeHandler(e.target.value)}>
                                                                    <option value="PARTY">Party</option>
                                                                    <option value="EXECUTIVE">Executive</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col> : null
                                                    }
                                                    {npartyy === "EXECUTIVE" && pdPaymentType === "PB" ?
                                                        <Col className="col-md-3 col-6">
                                                            <Form.Label>Executive<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={nExecutive}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={Picklist.fetchExecutivePicklist}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleExecutiveChange}
                                                                isDisabled={scrMode === "Q"}
                                                            >
                                                            </AsyncSelect>
                                                        </Col> : null
                                                    }

                                                    {pdPaymentType === "PB" && (piFundProcess.add == '1' || piFundProcess.edit == '1') && (
                                                        <>

                                                            <Col className="col-md-3 col-6">
                                                                <Form.Label>Bank Name</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions={false}
                                                                    defaultOptions={false}
                                                                    value={ldgAllBank}
                                                                    getOptionLabel={e => e.label + ' '}
                                                                    getOptionValue={e => e.id}
                                                                    loadOptions={Picklist.fetchAllBankPicklist}
                                                                    onInputChange={Picklist.handleInputChange}
                                                                    // onChange={handleAllBankChange}
                                                                    isDisabled={true}
                                                                >
                                                                </AsyncSelect>
                                                            </Col>

                                                            <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                                                <Form.Group>
                                                                    <Form.Label>Account Number</Form.Label>
                                                                    <Form.Control size='sm' placeholder='Account Number' type='text'
                                                                        maxLength={20}
                                                                        value={accountNumber}
                                                                        // onChange={e => otherChargeChange(e.target.value)}
                                                                        disabled={true}
                                                                    />
                                                                </Form.Group>
                                                            </Col>


                                                            <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                                                <Form.Group>
                                                                    <Form.Label> IFSC Code</Form.Label>
                                                                    <Form.Control size='sm' placeholder='IFSC Code' type='text'
                                                                        maxLength={20}
                                                                        value={ifscCode}
                                                                        // onChange={e => otherChargeChange(e.target.value)}
                                                                        disabled={true}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                    )}

                                                </Row>
                                                {
                                                    pdPaymentType === "BN" ?
                                                        <Row>
                                                            <Col className="col-md-3 col-6">
                                                                <Form.Group>
                                                                    <Form.Label>Reference No<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control placeholder='Reference No' maxLength={20} value={pdChequeNum} onChange={e => Common.validateAlpNumSplValue(e.target.value, setPdChequeNum)} />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        : pdPaymentType === "CQ" ?
                                                            <Row>
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Group>
                                                                        <Form.Label>Cheque No<span className="colorThemeRed">*</span></Form.Label>
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={chequeValue}
                                                                            getOptionLabel={e => e.label + ' '}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={(search) => Picklist.fetchChequeBookBankPicklist(search, pdGroupValue, pdAccountValue, piLocationValue)}
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={handleChequeValue}
                                                                        >
                                                                        </AsyncSelect>
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row> : null
                                                }
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => addPayment()}>Add</Button>
                                                    </Col>
                                                </Row>
                                            </>
                                    }
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Table responsive striped bordered>
                                            <thead>
                                                <tr>
                                                    <th>Type</th>
                                                    <th>Group</th>
                                                    <th>Account</th>
                                                    <th>Name</th>
                                                    <th>Amount</th>
                                                    <th>Refernce No</th>
                                                    <th>Executive</th>
                                                    <th>Account Type</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paymentData.map((item, index) => (
                                                        <>
                                                            <tr key={item.uniquekey}>
                                                                <td>
                                                                    {
                                                                        item.tp_payment_type === "BN"
                                                                            ? "Bank" : item.tp_payment_type === "CQ"
                                                                                ? "Cheque" : item.tp_payment_type === "CH"
                                                                                    ? "Cash" : item.tp_payment_type === "RC"
                                                                                        ? "Receivables" : item.tp_payment_type === "PB"
                                                                                            ? "Payables" : item.tp_payment_type === "AP"
                                                                                                ? "Advance Paid" : item.tp_payment_type === "AR"
                                                                                                    ? "Advance Received" : ""
                                                                    }
                                                                </td>
                                                                <td>{item.tp_group}</td>
                                                                <td>{item.tp_account}</td>
                                                                <td>{item.mvli_ledger_name}</td>
                                                                <td>{item.tp_amount}</td>
                                                                <td>{item.tp_payment_type === "CQ" ? item.tcbb_from : item.tp_payment_type === "BN" ? item.tp_cheque : ''}</td>
                                                                <td>{item.executive}</td>
                                                                <td>{item.nparty}</td>
                                                                <td>
                                                                    {
                                                                        scrMode !== "Q" ?
                                                                            <span className='colorThemeBlue pointer' onClick={() => deletePayment(item.uniquekey, item.delny)}>
                                                                                <FontAwesomeIcon icon={faTrash} />
                                                                            </span> : null
                                                                    }
                                                                </td>
                                                            </tr>
                                                            {item.accnum && item.accnum.trim() != "" && (
                                                                <tr key={`hi-${index}`}>
                                                                    <td colSpan={15}>
                                                                        Bank Code : {item.bank_code}, Account no : {item.accnum}, IFSC : {item.ifsc}
                                                                    </td>
                                                                </tr>
                                                            )}

                                                        </>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>

                                </Tab>
                            </Tabs>
                            <hr />
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.query === "1" && scrMode === "Q") ? <>
                                            {/* <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => print("D")}>With Deno</Button>&nbsp; */}
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => print("")}>Print</Button>&nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                        </> : null
                                    }

                                    {(userRight.query === "1" && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    }
                                    {
                                        scrMode === "Q" &&
                                        <Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                    }
                                    {
                                        (scrMode === "Q" && userCancelBillRight.query === "1") &&
                                        <>
                                            &nbsp;
                                            {dateChangeRight?.query === '1' && scrMode === "Q" &&
                                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => changeDateModal()}>Date Change</Button>}
                                        </>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                        </>
                }
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <span className="corner-span">{counter}</span>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                {msgTextYNBillDelete}
            </CancelDialog>
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            <Tran_date_change_modal openDateChangeModal={openDateChangeModal} setOpenDateChangeModal={setOpenDateChangeModal} changeDateObj={changeDateObj} setMsgBox={setMsgBox} setMsgText={setMsgText} fillViewForm={fillViewForm} />
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
        </>
    )
}

export default Tran_pi